var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main pd10" },
    [
      _c(
        "div",
        { staticClass: "setting flex-row jc-start mb10" },
        [
          _c(
            "el-button",
            {
              attrs: {
                icon: _vm.settingType ? "el-icon-edit" : "el-icon-view",
                size: "medium",
                type: _vm.settingType ? "warning" : "",
              },
              on: { click: _vm.handSetting },
            },
            [_vm._v(_vm._s(_vm.settingType ? "编辑" : "确定") + " ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "homeLayout mg8" },
        [
          _c("el-row", { attrs: { gutter: 15 } }, [
            _c(
              "div",
              { staticClass: "layout_bg bordersolid" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c("CropperView", {
                      attrs: {
                        imgSrc: _vm.firstScreenImage.pic,
                        disabled: _vm.settingType,
                        actionButtonFlag: true,
                        objectFit: "cover",
                        listIndex: 1,
                        maxVideoSize: _vm.uploadVideoSize,
                      },
                      on: {
                        updateChange: function ($event) {
                          return _vm.changeImage($event, _vm.firstScreenImage)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "w100 flex-row flex-w" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.firstScreenTitle
                              )
                            },
                          },
                          model: {
                            value: _vm.firstScreenTitle.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.firstScreenTitle, "valEn", $$v)
                            },
                            expression: "firstScreenTitle.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.firstScreenTitle
                              )
                            },
                          },
                          model: {
                            value: _vm.firstScreenTitle.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.firstScreenTitle, "valCn", $$v)
                            },
                            expression: "firstScreenTitle.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        { staticClass: "flex-row ai-end jc-start iconBox" },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.firstScreenTitle)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8 mb8",
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.firstScreenContent
                              )
                            },
                          },
                          model: {
                            value: _vm.firstScreenContent.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.firstScreenContent, "valEn", $$v)
                            },
                            expression: "firstScreenContent.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8 mb8",
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.firstScreenContent
                              )
                            },
                          },
                          model: {
                            value: _vm.firstScreenContent.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.firstScreenContent, "valCn", $$v)
                            },
                            expression: "firstScreenContent.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        { staticClass: "flex-row ai-end jc-start iconBox" },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.firstScreenContent)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "layout_aboutUs bordersolid mt4" }, [
              _c("div", { staticClass: "flex-row jc-center mt8" }, [
                _c(
                  "div",
                  { staticClass: "w100" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput($event, _vm.aboutUsTitle)
                            },
                          },
                          model: {
                            value: _vm.aboutUsTitle.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.aboutUsTitle, "valEn", $$v)
                            },
                            expression: "aboutUsTitle.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput($event, _vm.aboutUsTitle)
                            },
                          },
                          model: {
                            value: _vm.aboutUsTitle.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.aboutUsTitle, "valCn", $$v)
                            },
                            expression: "aboutUsTitle.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        { staticClass: "flex-row ai-end jc-start iconBox" },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.aboutUsTitle)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: {
                            type: "textarea",
                            rows: "5",
                            disabled: _vm.settingType,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput($event, _vm.aboutUsContent)
                            },
                          },
                          model: {
                            value: _vm.aboutUsContent.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.aboutUsContent, "valEn", $$v)
                            },
                            expression: "aboutUsContent.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: {
                            type: "textarea",
                            rows: "5",
                            disabled: _vm.settingType,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput($event, _vm.aboutUsContent)
                            },
                          },
                          model: {
                            value: _vm.aboutUsContent.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.aboutUsContent, "valCn", $$v)
                            },
                            expression: "aboutUsContent.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex-row ai-end jc-start iconBox",
                          staticStyle: { height: "115px" },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.aboutUsContent)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "flex-row jc-evenly mt8 mb8" },
                _vm._l(_vm.aboutUsList, function (item, index) {
                  return _c("el-col", { key: index, attrs: { span: 8 } }, [
                    _c("div", { staticClass: "flex-row" }, [
                      _c(
                        "div",
                        {
                          staticStyle: { "text-align": "center", width: "95%" },
                        },
                        [
                          _c("el-input", {
                            staticClass: "mt8",
                            attrs: { disabled: _vm.settingType },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput($event, item)
                              },
                            },
                            model: {
                              value: item.valNum,
                              callback: function ($$v) {
                                _vm.$set(item, "valNum", $$v)
                              },
                              expression: "item.valNum",
                            },
                          }),
                          _c("el-input", {
                            staticClass: "mt8",
                            attrs: { disabled: _vm.settingType },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput($event, item)
                              },
                            },
                            model: {
                              value: item.valEn,
                              callback: function ($$v) {
                                _vm.$set(item, "valEn", $$v)
                              },
                              expression: "item.valEn",
                            },
                          }),
                          _c("el-input", {
                            staticClass: "mt8",
                            attrs: { disabled: _vm.settingType },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput($event, item)
                              },
                            },
                            model: {
                              value: item.valCn,
                              callback: function ($$v) {
                                _vm.$set(item, "valCn", $$v)
                              },
                              expression: "item.valCn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { width: "5%" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex-row ai-end jc-start iconBox",
                            staticStyle: {
                              height: "140px",
                              "margin-left": "10px",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-s-tools",
                              staticStyle: { "font-size": "20px" },
                              on: {
                                click: function ($event) {
                                  return _vm.handFont(item)
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                }),
                1
              ),
              _c(
                "div",
                { staticClass: "flex-row fw-warp mb8" },
                _vm._l(_vm.aboutUsBasicsList, function (bitem) {
                  return _c("el-col", { key: bitem.id, attrs: { span: 12 } }, [
                    _c("div", { staticClass: "flex-row" }, [
                      _c(
                        "div",
                        {
                          staticClass: " w100 mt8",
                          staticStyle: { width: "95%" },
                        },
                        _vm._l(bitem, function (bcitem) {
                          return _c(
                            "div",
                            { key: bcitem.id },
                            [
                              bcitem.type == "Image"
                                ? _c("image-upload-new", {
                                    staticClass: "mb8",
                                    attrs: {
                                      disabled: _vm.settingType,
                                      limit: 1,
                                      tip: "单个图片不要超过10M",
                                    },
                                    on: {
                                      updateChange: function ($event) {
                                        return _vm.changeImage($event, bcitem)
                                      },
                                    },
                                    model: {
                                      value: bcitem.pic,
                                      callback: function ($$v) {
                                        _vm.$set(bcitem, "pic", $$v)
                                      },
                                      expression: "bcitem.pic",
                                    },
                                  })
                                : _vm._e(),
                              bcitem.type == "Title"
                                ? _c(
                                    "div",
                                    { staticClass: "flex-row" },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: _vm.settingType },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeInput(
                                              $event,
                                              bcitem
                                            )
                                          },
                                        },
                                        model: {
                                          value: bcitem.valEn,
                                          callback: function ($$v) {
                                            _vm.$set(bcitem, "valEn", $$v)
                                          },
                                          expression: "bcitem.valEn",
                                        },
                                      }),
                                      _c("el-input", {
                                        staticClass: "ml8",
                                        attrs: { disabled: _vm.settingType },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeInput(
                                              $event,
                                              bcitem
                                            )
                                          },
                                        },
                                        model: {
                                          value: bcitem.valCn,
                                          callback: function ($$v) {
                                            _vm.$set(bcitem, "valCn", $$v)
                                          },
                                          expression: "bcitem.valCn",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              bcitem.type == "Tip"
                                ? _c(
                                    "div",
                                    { staticClass: "flex-row mt8" },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: _vm.settingType },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeInput(
                                              $event,
                                              bcitem
                                            )
                                          },
                                        },
                                        model: {
                                          value: bcitem.valEn,
                                          callback: function ($$v) {
                                            _vm.$set(bcitem, "valEn", $$v)
                                          },
                                          expression: "bcitem.valEn",
                                        },
                                      }),
                                      _c("el-input", {
                                        staticClass: "ml8",
                                        attrs: { disabled: _vm.settingType },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeInput(
                                              $event,
                                              bcitem
                                            )
                                          },
                                        },
                                        model: {
                                          value: bcitem.valCn,
                                          callback: function ($$v) {
                                            _vm.$set(bcitem, "valCn", $$v)
                                          },
                                          expression: "bcitem.valCn",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "flex-row ai-end jc-start",
                          staticStyle: { width: "5%" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-row ai-center jc-center iconBox",
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-s-tools",
                                staticStyle: { "font-size": "20px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handFont(bitem)
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                1
              ),
            ]),
            _c("div", { staticClass: "ourProject bordersolid mt4" }, [
              _c("div", { staticClass: "flex-row ai-center jc-center mt8" }, [
                _c(
                  "div",
                  { staticClass: "w100" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.ourProjectTitle
                              )
                            },
                          },
                          model: {
                            value: _vm.ourProjectTitle.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.ourProjectTitle, "valEn", $$v)
                            },
                            expression: "ourProjectTitle.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.ourProjectTitle
                              )
                            },
                          },
                          model: {
                            value: _vm.ourProjectTitle.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.ourProjectTitle, "valCn", $$v)
                            },
                            expression: "ourProjectTitle.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex-row ai-end jc-start iconBox",
                          staticStyle: { height: "35px" },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.ourProjectTitle)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "flex-row jc-center mt16" }, [
                _c("div", { staticClass: "pd16" }, [
                  _vm._v(
                    "产品图册展示,请前往产品图册配置图册,选择是否在首页显示为是"
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "howWorks bordersolid mt4 pd16" }, [
              _c("div", { staticClass: "flex-row jc-center mt8" }, [
                _c(
                  "div",
                  { staticClass: "w100" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput($event, _vm.howWorksTitle)
                            },
                          },
                          model: {
                            value: _vm.howWorksTitle.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.howWorksTitle, "valEn", $$v)
                            },
                            expression: "howWorksTitle.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput($event, _vm.howWorksTitle)
                            },
                          },
                          model: {
                            value: _vm.howWorksTitle.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.howWorksTitle, "valCn", $$v)
                            },
                            expression: "howWorksTitle.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        { staticClass: "flex-row ai-end jc-start iconBox" },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.howWorksTitle)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: {
                            type: "textarea",
                            rows: "5",
                            disabled: _vm.settingType,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.howWorksContent
                              )
                            },
                          },
                          model: {
                            value: _vm.howWorksContent.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.howWorksContent, "valEn", $$v)
                            },
                            expression: "howWorksContent.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: {
                            type: "textarea",
                            rows: "5",
                            disabled: _vm.settingType,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.howWorksContent
                              )
                            },
                          },
                          model: {
                            value: _vm.howWorksContent.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.howWorksContent, "valCn", $$v)
                            },
                            expression: "howWorksContent.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex-row ai-end jc-start iconBox",
                          staticStyle: { height: "115px" },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.howWorksContent)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "mt8" }, [
                _c("div", {}, [_vm._v("步骤条：")]),
                _c(
                  "div",
                  { staticClass: "flex-row flex-w jc-evenly mb8" },
                  _vm._l(_vm.howWorksStepList, function (hitem) {
                    return _c(
                      "el-col",
                      { key: hitem.id, attrs: { span: 12 } },
                      [
                        _c(
                          "div",
                          { staticClass: " mt32" },
                          _vm._l(hitem, function (citem) {
                            return _c(
                              "div",
                              { key: citem.id },
                              [
                                citem.type == "image"
                                  ? _c("image-upload-new", {
                                      staticClass: "mb8",
                                      attrs: {
                                        disabled: _vm.settingType,
                                        limit: 1,
                                        tip: "单个图片不要超过10M",
                                      },
                                      on: {
                                        updateChange: function ($event) {
                                          return _vm.changeImage($event, citem)
                                        },
                                      },
                                      model: {
                                        value: citem.pic,
                                        callback: function ($$v) {
                                          _vm.$set(citem, "pic", $$v)
                                        },
                                        expression: "citem.pic",
                                      },
                                    })
                                  : citem.type == "detail"
                                  ? _c(
                                      "div",
                                      { staticClass: "flex-row mt8" },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: "5",
                                            disabled: _vm.settingType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeInput(
                                                $event,
                                                citem
                                              )
                                            },
                                          },
                                          model: {
                                            value: citem.valEn,
                                            callback: function ($$v) {
                                              _vm.$set(citem, "valEn", $$v)
                                            },
                                            expression: "citem.valEn",
                                          },
                                        }),
                                        _c("el-input", {
                                          staticClass: "ml8",
                                          attrs: {
                                            type: "textarea",
                                            rows: "5",
                                            disabled: _vm.settingType,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeInput(
                                                $event,
                                                citem
                                              )
                                            },
                                          },
                                          model: {
                                            value: citem.valCn,
                                            callback: function ($$v) {
                                              _vm.$set(citem, "valCn", $$v)
                                            },
                                            expression: "citem.valCn",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-row ai-end jc-center iconBox",
                                            staticStyle: {
                                              width: "80px",
                                              height: "115px",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-s-tools",
                                              staticStyle: {
                                                "font-size": "20px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handFont(citem)
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticClass: "flex-row mt8" },
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: _vm.settingType },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeInput(
                                                $event,
                                                citem
                                              )
                                            },
                                          },
                                          model: {
                                            value: citem.valEn,
                                            callback: function ($$v) {
                                              _vm.$set(citem, "valEn", $$v)
                                            },
                                            expression: "citem.valEn",
                                          },
                                        }),
                                        _c("el-input", {
                                          staticClass: "ml8",
                                          attrs: { disabled: _vm.settingType },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeInput(
                                                $event,
                                                citem
                                              )
                                            },
                                          },
                                          model: {
                                            value: citem.valCn,
                                            callback: function ($$v) {
                                              _vm.$set(citem, "valCn", $$v)
                                            },
                                            expression: "citem.valCn",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-row ai-center jc-center iconBox",
                                            staticStyle: {
                                              width: "80px",
                                              height: "40px",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-s-tools",
                                              staticStyle: {
                                                "font-size": "20px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handFont(citem)
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "ourService bordersolid mt4 pd4" }, [
              _c("div", { staticClass: "flex-row jc-center mt8" }, [
                _c(
                  "div",
                  { staticClass: "w100" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.ourServiceTitle
                              )
                            },
                          },
                          model: {
                            value: _vm.ourServiceTitle.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.ourServiceTitle, "valEn", $$v)
                            },
                            expression: "ourServiceTitle.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          attrs: { disabled: _vm.settingType },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.ourServiceTitle
                              )
                            },
                          },
                          model: {
                            value: _vm.ourServiceTitle.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.ourServiceTitle, "valCn", $$v)
                            },
                            expression: "ourServiceTitle.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        { staticClass: "flex-row ai-end jc-start iconBox" },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.ourServiceTitle)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: {
                            type: "textarea",
                            rows: "5",
                            disabled: _vm.settingType,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.ourServiceContent
                              )
                            },
                          },
                          model: {
                            value: _vm.ourServiceContent.valEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.ourServiceContent, "valEn", $$v)
                            },
                            expression: "ourServiceContent.valEn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 11 } },
                      [
                        _c("el-input", {
                          staticClass: "mt8",
                          attrs: {
                            type: "textarea",
                            rows: "5",
                            disabled: _vm.settingType,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeInput(
                                $event,
                                _vm.ourServiceContent
                              )
                            },
                          },
                          model: {
                            value: _vm.ourServiceContent.valCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.ourServiceContent, "valCn", $$v)
                            },
                            expression: "ourServiceContent.valCn",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 2 } }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex-row ai-end jc-start iconBox",
                          staticStyle: { height: "115px" },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-s-tools",
                            staticStyle: { "font-size": "20px" },
                            on: {
                              click: function ($event) {
                                return _vm.handFont(_vm.ourServiceContent)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "flex-row flex-w  mb8" },
                _vm._l(_vm.ourfiveServiceList, function (oitem) {
                  return _c("el-col", { key: oitem.id, attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: " mt16" },
                      _vm._l(oitem, function (ocitem) {
                        return _c(
                          "div",
                          { key: ocitem.id },
                          [
                            ocitem.type == "image"
                              ? _c("image-upload-new", {
                                  staticClass: "mb8",
                                  attrs: {
                                    disabled: _vm.settingType,
                                    limit: 1,
                                    tip: "单个图片不要超过10M",
                                  },
                                  on: {
                                    updateChange: function ($event) {
                                      return _vm.changeImage($event, ocitem)
                                    },
                                  },
                                  model: {
                                    value: ocitem.pic,
                                    callback: function ($$v) {
                                      _vm.$set(ocitem, "pic", $$v)
                                    },
                                    expression: "ocitem.pic",
                                  },
                                })
                              : _c(
                                  "div",
                                  { staticClass: "flex-row" },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: _vm.settingType },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeInput($event, ocitem)
                                        },
                                      },
                                      model: {
                                        value: ocitem.valEn,
                                        callback: function ($$v) {
                                          _vm.$set(ocitem, "valEn", $$v)
                                        },
                                        expression: "ocitem.valEn",
                                      },
                                    }),
                                    _vm.activeName == "en"
                                      ? _c("el-input", {
                                          staticClass: "ml8",
                                          attrs: { disabled: _vm.settingType },
                                          on: {
                                            change: function ($event) {
                                              return _vm.changeInput(
                                                $event,
                                                ocitem
                                              )
                                            },
                                          },
                                          model: {
                                            value: ocitem.valCn,
                                            callback: function ($$v) {
                                              _vm.$set(ocitem, "valCn", $$v)
                                            },
                                            expression: "ocitem.valCn",
                                          },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-row ai-end jc-center iconBox",
                                        staticStyle: {
                                          width: "80px",
                                          height: "40px",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-s-tools",
                                          staticStyle: { "font-size": "20px" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handFont(ocitem)
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                }),
                1
              ),
            ]),
            _c("div", { staticClass: "slideshowBox bordersolid mt4 pd16" }, [
              _c("div", {}, [
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "mb8" }, [_vm._v("底图:")]),
                    _c("image-upload-new", {
                      staticClass: "mb8",
                      attrs: {
                        disabled: _vm.settingType,
                        limit: 1,
                        tip: "单个图片不要超过10M",
                      },
                      on: {
                        updateChange: function ($event) {
                          return _vm.changeImage($event, _vm.slideshowBgImage)
                        },
                      },
                      model: {
                        value: _vm.slideshowBgImage.pic,
                        callback: function ($$v) {
                          _vm.$set(_vm.slideshowBgImage, "pic", $$v)
                        },
                        expression: "slideshowBgImage.pic",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "flex-row flex-w" }, [
                  _c("div", { staticClass: "mb8" }, [_vm._v("左边内容:")]),
                  _c(
                    "div",
                    { staticClass: "w100" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.settingType },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput(
                                  $event,
                                  _vm.slideshowleftTitle
                                )
                              },
                            },
                            model: {
                              value: _vm.slideshowleftTitle.valEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.slideshowleftTitle, "valEn", $$v)
                              },
                              expression: "slideshowleftTitle.valEn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.settingType },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput(
                                  $event,
                                  _vm.slideshowleftTitle
                                )
                              },
                            },
                            model: {
                              value: _vm.slideshowleftTitle.valCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.slideshowleftTitle, "valCn", $$v)
                              },
                              expression: "slideshowleftTitle.valCn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }, [
                        _c(
                          "div",
                          { staticClass: "flex-row ai-end jc-start iconBox" },
                          [
                            _c("i", {
                              staticClass: "el-icon-s-tools",
                              staticStyle: { "font-size": "20px" },
                              on: {
                                click: function ($event) {
                                  return _vm.handFont(_vm.slideshowleftTitle)
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c("el-input", {
                            staticClass: "mt8",
                            attrs: {
                              type: "textarea",
                              rows: "5",
                              disabled: _vm.settingType,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput(
                                  $event,
                                  _vm.slideshowleftContent
                                )
                              },
                            },
                            model: {
                              value: _vm.slideshowleftContent.valEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.slideshowleftContent, "valEn", $$v)
                              },
                              expression: "slideshowleftContent.valEn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c("el-input", {
                            staticClass: "mt8",
                            attrs: {
                              type: "textarea",
                              rows: "5",
                              disabled: _vm.settingType,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput(
                                  $event,
                                  _vm.slideshowleftContent
                                )
                              },
                            },
                            model: {
                              value: _vm.slideshowleftContent.valCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.slideshowleftContent, "valCn", $$v)
                              },
                              expression: "slideshowleftContent.valCn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex-row ai-end jc-start iconBox",
                            staticStyle: { height: "115px" },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-s-tools",
                              staticStyle: { "font-size": "20px" },
                              on: {
                                click: function ($event) {
                                  return _vm.handFont(_vm.slideshowleftContent)
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("div", { staticClass: "flex-row flex-w" }, [
                _c("div", { staticClass: "mb8 mt8" }, [_vm._v("右边介绍:")]),
                _c(
                  "div",
                  { staticClass: "flex-row flex-w  mb8" },
                  _vm._l(_vm.slideshowRightList, function (oitem, oindex) {
                    return _c(
                      "el-col",
                      { key: oitem.id, attrs: { span: 12 } },
                      [
                        _c(
                          "div",
                          { staticClass: " mt16" },
                          [
                            _c("div", { staticClass: "mb8" }, [
                              _vm._v("第" + _vm._s(oindex + 1) + "个"),
                            ]),
                            _vm._l(oitem, function (soitem) {
                              return _c(
                                "div",
                                { key: soitem.id, staticClass: " mt8" },
                                [
                                  soitem.type == "title"
                                    ? _c(
                                        "div",
                                        { staticClass: "flex-row" },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: _vm.settingType,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeInput(
                                                  $event,
                                                  soitem
                                                )
                                              },
                                            },
                                            model: {
                                              value: soitem.valEn,
                                              callback: function ($$v) {
                                                _vm.$set(soitem, "valEn", $$v)
                                              },
                                              expression: "soitem.valEn",
                                            },
                                          }),
                                          _c("el-input", {
                                            staticClass: "ml8",
                                            attrs: {
                                              disabled: _vm.settingType,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeInput(
                                                  $event,
                                                  soitem
                                                )
                                              },
                                            },
                                            model: {
                                              value: soitem.valCn,
                                              callback: function ($$v) {
                                                _vm.$set(soitem, "valCn", $$v)
                                              },
                                              expression: "soitem.valCn",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-row ai-center jc-center iconBox",
                                              staticStyle: {
                                                width: "80px",
                                                height: "40px",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-s-tools",
                                                staticStyle: {
                                                  "font-size": "20px",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handFont(soitem)
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "flex-row" },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              type: "textarea",
                                              rows: "5",
                                              disabled: _vm.settingType,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeInput(
                                                  $event,
                                                  soitem
                                                )
                                              },
                                            },
                                            model: {
                                              value: soitem.valEn,
                                              callback: function ($$v) {
                                                _vm.$set(soitem, "valEn", $$v)
                                              },
                                              expression: "soitem.valEn",
                                            },
                                          }),
                                          _c("el-input", {
                                            staticClass: "ml8",
                                            attrs: {
                                              type: "textarea",
                                              rows: "5",
                                              disabled: _vm.settingType,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeInput(
                                                  $event,
                                                  soitem
                                                )
                                              },
                                            },
                                            model: {
                                              value: soitem.valCn,
                                              callback: function ($$v) {
                                                _vm.$set(soitem, "valCn", $$v)
                                              },
                                              expression: "soitem.valCn",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex-row ai-end jc-center iconBox",
                                              staticStyle: {
                                                width: "80px",
                                                height: "115px",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-s-tools",
                                                staticStyle: {
                                                  "font-size": "20px",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handFont(soitem)
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "subscribeBox bordersolid mt4 mb32 pd4" },
              [
                _c("div", { staticClass: "flex-row jc-center mt8 mb8" }, [
                  _c(
                    "div",
                    { staticClass: "w100" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.settingType },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput(
                                  $event,
                                  _vm.subscribeTitle
                                )
                              },
                            },
                            model: {
                              value: _vm.subscribeTitle.valEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.subscribeTitle, "valEn", $$v)
                              },
                              expression: "subscribeTitle.valEn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c("el-input", {
                            attrs: { disabled: _vm.settingType },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput(
                                  $event,
                                  _vm.subscribeTitle
                                )
                              },
                            },
                            model: {
                              value: _vm.subscribeTitle.valCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.subscribeTitle, "valCn", $$v)
                              },
                              expression: "subscribeTitle.valCn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }, [
                        _c(
                          "div",
                          { staticClass: "flex-row ai-end jc-start iconBox" },
                          [
                            _c("i", {
                              staticClass: "el-icon-s-tools",
                              staticStyle: { "font-size": "20px" },
                              on: {
                                click: function ($event) {
                                  return _vm.handFont(_vm.subscribeTitle)
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c("el-input", {
                            staticClass: "mt8",
                            attrs: {
                              type: "textarea",
                              rows: "5",
                              disabled: _vm.settingType,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput(
                                  $event,
                                  _vm.subscribeContent
                                )
                              },
                            },
                            model: {
                              value: _vm.subscribeContent.valEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.subscribeContent, "valEn", $$v)
                              },
                              expression: "subscribeContent.valEn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c("el-input", {
                            staticClass: "mt8",
                            attrs: {
                              type: "textarea",
                              rows: "5",
                              disabled: _vm.settingType,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeInput(
                                  $event,
                                  _vm.subscribeContent
                                )
                              },
                            },
                            model: {
                              value: _vm.subscribeContent.valCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.subscribeContent, "valCn", $$v)
                              },
                              expression: "subscribeContent.valCn",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 2 } }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex-row ai-end jc-start iconBox",
                            staticStyle: { height: "115px" },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-s-tools",
                              staticStyle: { "font-size": "20px" },
                              on: {
                                click: function ($event) {
                                  return _vm.handFont(_vm.subscribeContent)
                                },
                              },
                            }),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c("fontSizeFamilyForm", { ref: "fontSizeFamilyFormRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }